const getCourseList = state => state?.courses?.coursesList
const getSkillList = state => state?.courses?.skillList

const selectors = {
  getCourseList,
  getSkillList,
}

export default selectors
